import { render, staticRenderFns } from "./AlarmConfigurationForm.vue?vue&type=template&id=8fa7990e&scoped=true"
import script from "./AlarmConfigurationForm.vue?vue&type=script&lang=js"
export * from "./AlarmConfigurationForm.vue?vue&type=script&lang=js"
import style0 from "./AlarmConfigurationForm.vue?vue&type=style&index=0&id=8fa7990e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa7990e",
  null
  
)

export default component.exports